if (!customElements.get('journal-blog')) {
  class JournalBlog extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true });
        return;
      }

      this.initialize();
    }

    initialize() {
      if (this.dataset.mobileMoreReady === 'true') return;

      const button = this.querySelector('[data-journal-mobile-more]');
      const cards = [...this.querySelectorAll('.journal-card--compact')];

      if (!button || cards.length <= 5) return;

      this.dataset.mobileMoreReady = 'true';
      this.classList.add('is-mobile-collapsed');
      button.hidden = false;

      button.addEventListener(
        'click',
        () => {
          this.classList.remove('is-mobile-collapsed');
          button.setAttribute('aria-expanded', 'true');
          button.hidden = true;
        },
        { once: true }
      );
    }
  }

  customElements.define('journal-blog', JournalBlog);
}
